import { Check } from "lucide-react";
import Card from "./card"

const services = [
  "Social Media Account Setup and Optimization",
  "Expert Social Media Management and Strategies",
  "Professional content/ad creatives (graphics, carousels, video snippets)",
  "Social media content calendar (posts, reels, captions)",
  "Community management and engagement support",
  "Ad Account setup and optimization with tracking pixels",
  "Paid ad campaigns with retargeting strategies",
  "Regular monitoring and adjustments to maximize ROI",
  "SEO articles and optimized web content",
  "Influencer & UGC campaigns (micro and macro)",
  "Weekly or monthly performance reports and strategy calls",
  "Dedicated support and consultation",
];



export const WhatSection = () => {
  return (
    <section className="py-18 bg-background mt-5">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 text-foreground">
            What You Get
          </h2>
          <p className="text-center text-muted-foreground mb-6 text-lg">
            When you work with us, here's what we put in place for you:
          </p>
          
          <Card className="p-8 shadow-[0_8px_24px_0_rgba(59,130,246,0.15)]">
            <div className="grid md:grid-cols-2 gap-3 sm:gap-5">
              {services.map((service, index) => (
                <div 
                  key={index} 
                  className="flex items-start gap-3 group hover:translate-x-2 transition-transform duration-300"
                >
                  <div className="flex-shrink-0 ">
                    <div className="bg-blue-100 p-1.5 rounded-full group-hover:bg-primary/20 transition-colors">
                      <Check className="h-5 w-5 text-blue-900" />
                    </div>
                  </div>
                  <p className="text-foreground leading-relaxed">{service}</p>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};
